import {createContext, Dispatch} from 'react'
import {TagsComponentState} from './types/tags-component-state'
import {AllActions} from './state/actions'
import {DEFAULT_TAG_COMPONENT_STATE} from './types/default-tag-component-state'

export const tagsComponentContext = createContext<{
    state: TagsComponentState
    dispatch: Dispatch<AllActions> | undefined
}>({state: DEFAULT_TAG_COMPONENT_STATE, dispatch: undefined})
